import React, { Component } from 'react'
import { Row, Col } from 'antd'
import imgActive from 'assets/image/active@3x.png'

class Seq extends Component {
  render() {
    const { current, seq } = this.props
    const bgPos = current * 29 * (current >= 9 ? 1.02 : 1)

    return (
      <Row>
        <Col
          style={{
            background: `url(${imgActive}) no-repeat`,
            backgroundPosition: `${bgPos}px`,
            backgroundSize: 30,
            transition: 'all .3s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            width: 300,
            margin: '0 auto',
          }}
        >
          {seq.map(index => {
            return (
              <div style={{ display: 'inline-block', lineHeight: '30px' }} key={index}>
                {index + 1}
              </div>
            )
          })}
        </Col>
      </Row>
    )
  }
}

export default Seq
